module.exports = __webpack_public_path__ + "4e53ecdb7527ea63c1397973109bb5e2.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-74@2x.png
// module id = 535
// module chunks = 0